import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/styles/makeStyles'
import { Product } from '../model'

const noImageSrc = 'https://lvdneng.rosselcdn.net/sites/default/files/dpistyles_v2/ena_16_9_extra_big/2018/09/29/node_459296/39761634/public/2018/09/29/B9717088089Z.1_20180929132433_000%2BGROC4L01A.1-0.jpg?itok=Wn785hL7'

const useStyles = makeStyles((theme: any) => ({
    root: {
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
        '& .ProductNameTitleSecondary': {
            margin: theme.spacing(3, 0, 2)
        },
        '& .ProductNameImage': {
            margin: '0 auto',
            marginBottom: theme.spacing(5),
            width: '50%'
        }
        /*'& img': {
            [theme.breakpoints.down('sm')]: {
                height: '300px',
            }
        }*/
    }
}), { name: 'ProductName' })

export function ProductNameView(props: { product: Product; pictureVisible?: boolean }) {
    const classes = useStyles(props)
    return <Box className={classes.root}>
        {!!props.pictureVisible
            ? <Typography variant='h5' className='ProductNameTitleSecondary'>{props.product.name}</Typography>
            : <Typography variant='h4' className='ProductNameTitle'>{props.product.name}</Typography>}
        {!!props.pictureVisible && <Box className='ProductNameImage'>
            <img src={props.product.images && props.product.images.length ? props.product.images[0].src : noImageSrc}
                style={{ maxWidth: '100%' }} />
        </Box>}
    </Box>
}